import { LaboratoryCreationParams, LaboratoryData, LaboratoryUpdationParams } from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/laboratory';

interface LaboratoryResultParams {
    userId: string;
    results: {
        referralId: string;
        serviceId: string;
        status: string;
        params: {
            value: string;
            name: string;
            group: string;
            refText: string;
            approvedBy: string;
            resultDate: string;
        }[];
    }[];
}

export class LaboratoryApi {
    public static async setResult(params: LaboratoryResultParams): Promise<void> {
        await axios.put(`${BASE_URL}/result`, params);
    }

    public static async getList(): Promise<LaboratoryData[]> {
        const res = await axios.get(BASE_URL);

        return res.data.laboratories;
    }

    public static async create(laboratory: LaboratoryCreationParams): Promise<void> {
        await axios.post(BASE_URL, {
            laboratory,
        });
    }

    public static async update(id: string, laboratory: LaboratoryUpdationParams): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, {
            laboratory,
        });
    }

    public static async delete(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`);
    }
}

export { BASE_URL as LABORATORY_BASE_URL };
